import React, { useEffect, useState } from "react"
import { motion, AnimatePresence } from "framer-motion"

const STORAGE_KEY = "va_feedback_prompt_dismissed"

export default function SmartFeedbackSystem({ FeedbackModal, delay = 10000, handleCTAClick, startTimer = true }) {
  const [showPrompt, setShowPrompt] = useState(false)
  const [showCTA, setShowCTA] = useState(false)
  const [showModal, setShowModal] = useState(false)

  useEffect(() => {
    if (!startTimer) return // 👈 KEY FIX

    const dismissed = localStorage.getItem(STORAGE_KEY)

    if (dismissed) {
      setShowCTA(true)
      return
    }

    const timer = setTimeout(() => {
      setShowPrompt(true)
    }, delay)

    return () => clearTimeout(timer)
  }, [startTimer, delay])

  const handleDismiss = () => {
    localStorage.setItem(STORAGE_KEY, Date.now())
    setShowPrompt(false)
    setShowCTA(true)
  }

  const handleOpenModal = () => {
    handleCTAClick()
    setShowPrompt(false)
  }

  const handleCloseModal = () => {
    setShowModal(false)
  }

  return (
    <>
      {/* BACKDROP */}
      <AnimatePresence>
        {showPrompt && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            // onClick={handleDismiss}
            style={{
              position: "fixed",
              inset: 0,
              zIndex: 1990,
              background: "radial-gradient(circle at center, rgba(0,0,0,0.35), rgba(0,0,0,0.55))",
              backdropFilter: "blur(4px)",
            }}
          />
        )}
      </AnimatePresence>

      {/* FEEDBACK PROMPT */}
      <AnimatePresence>
        {showPrompt && (
          <motion.div
            initial={{ opacity: 0, y: 40, scale: 0.95 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: 40 }}
            transition={{ duration: 0.35 }}
            style={{
              position: "fixed",
              width: 320,
              padding: 22,
              borderRadius: 16,
              background: "rgb(19 0 255 / 8%)",
              backdropFilter: "blur(16px)",
              border: "1px solid rgba(255,255,255,0.15)",
              boxShadow: "0 20px 60px rgba(0,0,0,0.35)",
              zIndex: 2000,
              maxWidth: "calc(100vw - 70px)",
            }}
            className="va-demo-feedback-prompt"
          >
            <div style={{ color: "white", fontWeight: 600 }}>Enjoying BoostDash?</div>

            <div
              style={{
                marginTop: 6,
                fontSize: 13,
                color: "rgba(255,255,255,0.75)",
              }}
            >
              Your feedback helps us improve the platform.
            </div>

            <div
              style={{
                display: "flex",
                gap: 10,
                marginTop: 16,
              }}
            >
              <motion.button
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.96 }}
                onClick={handleOpenModal}
                style={{
                  padding: "10px 14px",
                  borderRadius: 30,
                  border: "none",
                  cursor: "pointer",
                  color: "#fff",
                  fontWeight: 600,
                  background: "linear-gradient(135deg,var(--va-primary-color),var(--va-primary-color-1))",
                }}
              >
                Give Feedback
              </motion.button>

              <button
                onClick={handleDismiss}
                style={{
                  background: "transparent",
                  border: "none",
                  color: "rgba(255,255,255,0.7)",
                  cursor: "pointer",
                }}
              >
                I'm still exploring
              </button>
            </div>
          </motion.div>
        )}
      </AnimatePresence>

      {/* FLOATING CTA */}
      <AnimatePresence>
        {showCTA && !showModal && (
          <motion.button
            onClick={handleOpenModal}
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{
              opacity: 1,
              scale: 1,
              y: [0, -6, 0],
            }}
            transition={{
              duration: 3,
              repeat: Infinity,
              repeatType: "loop",
            }}
            style={{
              position: "fixed",
              bottom: 150,
              right: 28,
              padding: "14px 18px",
              borderRadius: 30,
              border: "none",
              cursor: "pointer",
              color: "#fff",
              fontWeight: 600,
              zIndex: 2000,
              background: "linear-gradient(135deg,var(--va-primary-color),var(--va-primary-color-1))",
              boxShadow: "0 10px 30px rgba(0,0,0,0.35)",
            }}
          >
            💬 Give Feedback
          </motion.button>
        )}
      </AnimatePresence>

      {/* FEEDBACK MODAL */}
      {FeedbackModal && <FeedbackModal open={showModal} onClose={handleCloseModal} handleCTAClick={handleCTAClick} />}
    </>
  )
}
